import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material";

const Titol = styled(Typography)(({ theme }) => ({
	color: theme.palette.admin.secondary,
}));

const Title = (props) => {
	const { title, subtitle, button } = props;

	return (
		<Box display={"flex"} justifyContent={"space-between"}>
			<Box>
				<Typography variant="h2" component="h2" gutterBottom>
					{title}
				</Typography>
				<Titol gutterBottom>{subtitle}</Titol>
			</Box>
			<Box m={2}>{button}</Box>
		</Box>
	);
};

export default Title;
